import {
  Box,
  Grid,
  Typography,
  FormControl,
  Tooltip,
  debounce,
  Divider
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CustomAutocomplete from 'components/Inputs/CustomAutocomplete';
import CustomTextField from 'components/Inputs/CustomTextField';
import { useEffect, useState } from 'react';
import { ReactComponent as ComingSoonIcon } from '../../assets/coming-soon-dp.svg'
import { getNewProgramSectorList, getProjectOwnerList, getE2EConfigurationMetadata } from 'service/service';
import { useTheme } from "@mui/material/styles";
import { AntSwitch, getAutocompleteCommonComponentsProps, getInputCustomCommonSx  } from './DataPipelineHelper';

export const DashboardDetails = ({ formDataDashboard, setFormDataDashboard, onValidityChange }: any) => {
  const theme = useTheme();
  const colors = theme.palette;
  const [dropdownLoading, setDropdownLoading] = useState<any>({
    business: false,
    sector: false,
    consumer: false,
    dependentReports: false,
    dataClassifications: false,
    downstreamSystems: false,
    dpmEmail: false,
    sustainleadEmail: false,
    escalationpointEmail: false,
  });
  const [businessList, setBusinessList] = useState<string[]>([]);
  const [frequencyList, setFrequencyList] = useState<string[]>([]);
  const [businessProgramList, setBusinessProgramList] =
    useState<string[]>([]);

  const [gdoList, setGdoList] = useState<string[]>([]);
  const [marketList, setMarketList] = useState<string[]>([]);
  const [businessStreamList, setBusinessStreamList] =
    useState<string[]>([]);
  const [domainList, setDomainList] = useState<string[]>([]);


  const renderDashboardOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: any,
    { selected }: { selected: boolean }
  ) => {
    return (
      <li
        {...props}
        style={{
          ...props.style,
          minHeight: '50px',
          height: '50px',
          boxSizing: 'border-box',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: selected
            ? '#D6EEF9'
            : '#FBFDFF',
          color: '#000000',
          fontSize: '14px',
          opacity: 1,
        }}
      >
        <span
          style={{
            color: '#000000',
            opacity: 1,
          }}
        >
          {option}
        </span>

        {selected && (
          <CheckIcon
            sx={{
              fontSize: '26px',
              color: '#004B87 !important',
              fill: '#004B87 !important',
              fontWeight: 700,
            }}
          />
        )}
      </li>
    );
  };

  const getDashboardDropdownProps = (colors: any) => {
    const commonProps = getAutocompleteCommonComponentsProps(colors);

    return {
      ...commonProps,

      paper: {
        ...commonProps?.paper,
        sx: {
          ...((commonProps?.paper as any)?.sx || {}),

          // Match the Select Business field width




          backgroundColor: '#FBFDFF !important',
          color: '#000000 !important',

          borderRadius: '0 4px 4px 4px',

          boxShadow:
            '0px 4px 44px 0px #00000026 !important',

          overflow: 'hidden',

          '& .MuiAutocomplete-listbox': {
            padding: '0 !important',
          },

          '& .MuiAutocomplete-option': {
            minHeight: '50px !important',
            height: '50px !important',
            boxSizing: 'border-box',

            padding: '0 24px !important',

            backgroundColor:
              '#FBFDFF !important',

            color:
              '#000000 !important',

            fontSize: '14px',

            opacity: '1 !important',

            // Text inside option
            '& span': {
              color:
                '#000000 !important',
            },

            '& .MuiTypography-root': {
              color:
                '#000000 !important',
            },

            // Hover
            '&:hover': {
              backgroundColor:
                '#39ACE733 !important',

              color:
                '#000000 !important',

              '& span': {
                color:
                  '#000000 !important',
              },

              '& .MuiTypography-root': {
                color:
                  '#000000 !important',
              },
            },

            // Selected
            '&.Mui-selected': {
              backgroundColor:
                '#39ACE733 !important',

              color:
                '#000000 !important',

              '& span': {
                color:
                  '#000000 !important',
              },

              '& .MuiTypography-root': {
                color:
                  '#000000 !important',
              },
            },

            // Selected + hover
            '&.Mui-selected:hover': {
              backgroundColor:
                '#39ACE733 !important',

              color:
                '#000000 !important',

              '& span': {
                color:
                  '#000000 !important',
              },

              '& .MuiTypography-root': {
                color:
                  '#000000 !important',
              },
            },

            // Keyboard focus
            '&.Mui-focused': {
              backgroundColor:
                '#39ACE733 !important',

              color:
                '#000000 !important',

              '& span': {
                color:
                  '#000000 !important',
              },

              '& .MuiTypography-root': {
                color:
                  '#000000 !important',
              },
            },
          },

          '& .MuiAutocomplete-noOptions, & .MuiAutocomplete-noOptions *': {
            color:
              '#000000 !important',
          },
        },
      },

      popper: {
        ...commonProps?.popper,
        sx: {
          ...((commonProps?.popper as any)?.sx || {}),

          // IMPORTANT: don't use 324px


          '& .MuiPaper-root': {
            width: '100% !important',
            minWidth: '100% !important',
            maxWidth: 'none !important',
          },
        },
      },
    };
  };

  const [sectorList, setSectorList] = useState<string[]>([]);
  const consumer: any[] = [];
  const report: any[] = [];
  const dataClass: any[] = [];
  const downStream: any[] = [];
  const [dpmEmailList, setDPMEmailList] = useState<any>([]);
  const [sustainleadEmailList, setSustainleadEmailList] = useState<any>([]);
  const escalationpointEmail: any[] = [];
  const toggleState = false;

  const requiredFields = [
    'dashboardName',
    'business',
    'sector',
    'businessProgram',
    'dpmEmail',
    'dpmContact',
    'sustainleadEmail',
    'sustainleadContact'
  ];

  const validateProgramFields = (formData: any) => {
    switch (formData.businessProgram) {

      case 'IBP':
        return Boolean(
          formData.gdo &&
          formData.market
        );

      case 'MOSAIC':
        return Boolean(
          formData.businessStream &&
          formData.market
        );

      case 'EDF':
        return Boolean(
          formData.domain
        );

      case 'MDIP':
        return Boolean(
          formData.businessApplication?.trim()
        );

      case 'Others':
        return true;

      default:
        return false;
    }
  };

  const inputCommonSx = {
    "& .MuiInputBase-input": {
      color: `${colors.input.text} !important`,
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "0.8px solid #71758FCC !important",
      },

      "&:hover fieldset": {
        border: "0.8px solid #71758FCC !important",
      },

      "&.Mui-focused fieldset": {
        border: "0.8px solid #71758FCC !important",
      },
    },

    "& .MuiInputLabel-root": {
      color: `${colors.input.text} !important`,
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: `${colors.input.text} !important`,
    },

    "& .MuiFormHelperText-root": {
      color: `${colors.input.text} !important`,
    },

    "& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input": {
      WebkitTextFillColor: `${colors.input.text} !important`,
    },

    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-disabled": {
      WebkitTextFillColor: `${colors.input.text} !important`,
    },
  };

  const commonCustomTextFieldProps = {
    InputLabelProps: {
      sx: {
        '&&': { color: `${colors.input.text} !important` },
        '&.Mui-focused': { color: `${colors.input.text} !important` },
        '&.MuiInputLabel-shrink': { color: `${colors.input.text} !important` },
      }
    },
    InputProps: {
      sx: {
        '&&': { color: `${colors.input.text} !important` },
        '& input': { color: `${colors.input.text} !important` }
      }
    },
    sx: {

      ...inputCommonSx
    }
  };

  const isFormValid = (formDataDashboard: any) => {

    const baseValid = requiredFields.every(field => {
      const value = formDataDashboard[field];

      if (value === null || value === undefined) {
        return false;
      }

      if (
        typeof value === 'string' &&
        !value.trim()
      ) {
        return false;
      }

      return true;
    });

    if (!baseValid) {
      return false;
    }

    return validateProgramFields(
      formDataDashboard
    );
  };

  const getConfigurationMetadata = async () => {
    try {
      setDropdownLoading((prev: any) => ({
        ...prev,
        business: true,
      }));

      const response = await getE2EConfigurationMetadata();

      const metadata = response?.data || response || {};

      setBusinessList(metadata.business || []);
      setFrequencyList(metadata.frequency || []);
      setBusinessProgramList(metadata.businessProgram || []);

      setGdoList(metadata.gdo || []);
      setMarketList(metadata.market || []);
      setBusinessStreamList(metadata.businessStream || []);
      setDomainList(metadata.domain || []);
    } catch (error) {
      console.error(
        'Failed to load E2E configuration metadata',
        error
      );

      // Optional: clear business list on API failure
      setBusinessList([]);
    } finally {
      setDropdownLoading((prev: any) => ({
        ...prev,
        business: false,
      }));
    }
  };


  useEffect(() => {
    getConfigurationMetadata();
    getSectorData();
    getOwnerList('', 'dpmEmail');
    getOwnerList('', 'sustainleadEmail');
  }, []);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isFormValid(formDataDashboard));
    }
  }, [formDataDashboard]);

  const getDashboardType = (businessProgram: any) =>
    businessProgram === 'Others'
      ? 'sector'
      : 'program';

  const handleChange = (
    event: any,
    newValue = '',
    type = ''
  ) => {

    if (type === 'businessProgram') {
      const program = newValue || '';

      setFormDataDashboard((prev: any) => ({
        ...prev,

        businessProgram: program,

        // clear fields belonging to previous program
        gdo: '',
        market: '',
        businessStream: '',
        domain: '',
        businessApplication: '',

        dashboardType:
          getDashboardType(program)
      }));

      return;
    }

    if (type === 'business') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        business: newValue || ''
      }));

      return;
    }

    if (type === 'frequency') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        frequency: newValue || ''
      }));

      return;
    }

    if (type === 'gdo') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        gdo: newValue || ''
      }));

      return;
    }

    if (type === 'market') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        market: newValue || ''
      }));

      return;
    }

    if (type === 'businessStream') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        businessStream: newValue || ''
      }));

      return;
    }

    if (type === 'domain') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        domain: newValue || ''
      }));

      return;
    }

    if (type === 'businessApplication') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        businessApplication: newValue || ''
      }));

      return;
    }
    if (type === 'sector') {
      setFormDataDashboard((prev: any) => ({
        ...prev,
        sector: newValue || ''
      }));

      return;
    }
    if (['dpmEmail', 'sustainleadEmail', 'escalationpointEmail'].includes(type)) {
      setFormDataDashboard({
        ...formDataDashboard,
        [type]: newValue || null
      });
      return;
    }
    if (event?.target) {
      setFormDataDashboard({
        ...formDataDashboard,
        [type]: event.target.value
      });
    } else if (type) {
      setFormDataDashboard({
        ...formDataDashboard,
        [type]: newValue
      });
    }

  };

  const handleOnBlur = (event: any, type: string) => {
    if (type === 'dashboardName' || type === 'description') {
      setFormDataDashboard({
        ...formDataDashboard,
        [type]: event.target.value.trim()
      });
    }
  };

  const validateAliasInput = (event: any) => {
    const allowedChars = /^[a-zA-Z0-9\s_-]*$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  };

  const debouncedGetOwnerList = debounce((name: string, type: string) => {
    getOwnerList(name, type);
  }, 400);

  const handleInputChange = (event: any, name: any, newInputValue: any) => {
    if ((name === 'dpmEmail' || name === 'sustainleadEmail')) {
      if (newInputValue?.length) {
        debouncedGetOwnerList(newInputValue, name);
      } else if (newInputValue === '') {
        getOwnerList('', name);
      } else {
        if (name === 'dpmEmail') setDPMEmailList([]);
        if (name === 'sustainleadEmail') setSustainleadEmailList([]);
      }
    }
  };


  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  }

  const getSectorData = async () => {
  try {
    setDropdownLoading(
      (previous: any) => ({
        ...previous,
        sector: true
      })
    );

    const response: any =
      await getNewProgramSectorList();

    const rawSectors =
      response?.data?.data?.sectors ??
      response?.data?.sectors ??
      [];

    const sectors =
      Array.isArray(rawSectors)
        ? rawSectors
            .filter(
              (sector): sector is string =>
                typeof sector === 'string'
            )
            .map((sector) =>
              sector.trim()
            )
            .filter(Boolean)
        : [];

    setSectorList([
      ...new Set(sectors)
    ]);
  } catch (error) {
    console.error(
      'Failed to load canonical sectors:',
      error
    );

    setSectorList([]);
  } finally {
    setDropdownLoading(
      (previous: any) => ({
        ...previous,
        sector: false
      })
    );
  }
};



  const getOwnerList = async (name = '', type = '') => {
    setDropdownLoading((prev: any) => ({
      ...prev,
      [type]: true
    }));
    let result = await getProjectOwnerList(name);
    setDropdownLoading((prev: any) => ({
      ...prev,
      [type]: false
    }));

    // Deduplicate using Set
    const seen = new Set();
    let mailData: string[] = [];
    result.data.projectOwnerNames.forEach((obj: string) => {
      let formattedData = (obj.includes('null') ? obj.replace('(null)', '') : obj).trim();
      if (formattedData && !seen.has(formattedData)) {
        seen.add(formattedData);
        mailData.push(formattedData);
      }
    });

    if (type === 'dpmEmail') setDPMEmailList(mailData);
    if (type === 'sustainleadEmail') setSustainleadEmailList(mailData);
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
    let value = event.target.value.replace(/[^0-9+-]/g, '');
    setFormDataDashboard({
      ...formDataDashboard,
      [field]: value
    });
  };

  return (
    <Box sx={{ mt: 3, padding: '24px', borderRadius: '8px' }}>
      <Typography variant="body2" sx={{ opacity: 0.7, mb: 4, fontStyle: 'italic', color: 'textLight.main' }}>
        ⓘ This section is to configure the dashboard.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box p={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '16px' }}
                >
                  <Typography
                    variant="subHeader"
                    color="dark.main"
                    style={{
                      color: 'rgba(0, 155, 216, 1)',
                      display: 'inline-block',
                      paddingRight: '20px',
                      position: 'absolute',
                      zIndex: 2
                    }}
                  >
                    Configuration
                  </Typography>
                  <Divider sx={{ flexGrow: 1, backgroundColor: 'rgba(0, 155, 216, 1)', marginLeft: 18 }} />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  id="DashboardName"
                  label={
                    <Box display="flex" alignItems="center">
                      Dashboard Name *
                    </Box>
                  }
                  name="DashboardName"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.dashboardName}
                  error={formDataDashboard.dashboardName?.length > 200}
                  helperText="Dashboard Name can't contain more that 200 characters."
                  onChange={(e) => handleChange(e, '', 'dashboardName')}
                  onBlur={(e) => handleOnBlur(e, 'dashboardName')}
                  onKeyDown={validateAliasInput}
                  sx={inputCommonSx}
                />
              </Grid>

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.business}
                    options={businessList}
                    noOptionsText="No business found"
                    value={formDataDashboard.business || null}
                    onChange={(e, val) =>
                      handleChange(e, val, 'business')
                    }
                    disabled={false}
                    textFieldLabel="Select Business *"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={getDashboardDropdownProps(colors)}
                    customTextFieldProps={commonCustomTextFieldProps}
                    renderOption={renderDashboardOption}
                  />
                </FormControl>
              </Grid>


              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    options={frequencyList}
                    noOptionsText="No frequency found"
                    value={
                      formDataDashboard.frequency || null
                    }
                    onChange={(e, val) =>
                      handleChange(e, val, 'frequency')
                    }
                    disabled={false}
                    textFieldLabel="Select Frequency"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    customTextFieldProps={
                      commonCustomTextFieldProps
                    }
                    renderOption={renderDashboardOption}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.sector}
                    options={sectorList}
                    noOptionsText="No sector found"
                    value={formDataDashboard.sector || null}
                    onChange={(e, val) =>
                      handleChange(e, val, 'sector')
                    }
                    disabled={false}
                    getOptionLabel={(option) => option || ''}
                    isOptionEqualToValue={(option, value) => option === value}
                    textFieldLabel="Select Sector *"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={getDashboardDropdownProps(colors)}
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />

                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  id="BusinessDomain"
                  label={
                    <Box display="flex" alignItems="center">
                      Business Domain
                    </Box>
                  }
                  name="BusinessDomain"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.businessDomain}
                  error={formDataDashboard.businessDomain?.length > 45}
                  helperText="Business Domain can't contain more that 45 characters."
                  onChange={(e) => handleChange(e, 'businessDomain')}
                  onBlur={(e) => handleOnBlur(e, 'businessDomain')}
                  onKeyDown={validateAliasInput}
                  disabled={true}
                  sx={inputCommonSx}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    options={businessProgramList}
                    noOptionsText="No business program found"
                    value={
                      formDataDashboard.businessProgram || null
                    }
                    onChange={(e, val) =>
                      handleChange(
                        e,
                        val,
                        'businessProgram'
                      )
                    }
                    disabled={false}
                    textFieldLabel="Select Business Program *"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={
                      commonCustomTextFieldProps
                    }
                  />
                </FormControl>
              </Grid>
              {formDataDashboard.businessProgram === 'MDIP' && (
                <Grid item xs={4}>
                  <CustomTextField
                    id="BusinessApplication"
                    label={
                      <Box display="flex" alignItems="center">
                        Business Application *
                      </Box>
                    }
                    name="BusinessApplication"
                    variant="outlined"
                    autoComplete="off"
                    value={formDataDashboard.businessApplication || ''}
                    onChange={(e) =>
                      handleChange(e, e.target.value, 'businessApplication')
                    }
                    onBlur={(e) => handleOnBlur(e, 'businessApplication')}
                    onKeyDown={validateAliasInput}
                    sx={inputCommonSx}

                  />
                </Grid>
              )}

              {formDataDashboard.businessProgram === 'IBP' && (
                <>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <CustomAutocomplete
                        options={gdoList}
                        noOptionsText="No GDO found"
                        value={
                          formDataDashboard.gdo || null
                        }
                        onChange={(e, val) =>
                          handleChange(e, val, 'gdo')
                        }
                        disabled={false}
                        textFieldLabel="Select GDO"
                        sx={getInputCustomCommonSx(
                          colors,
                          undefined,
                          '#39ACE7'
                        )}
                        componentsProps={
                          getDashboardDropdownProps(colors)
                        }
                        renderOption={renderDashboardOption}
                        customTextFieldProps={
                          commonCustomTextFieldProps
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <CustomAutocomplete
                        options={marketList}
                        noOptionsText="No market found"
                        value={
                          formDataDashboard.market || null
                        }
                        onChange={(e, val) =>
                          handleChange(e, val, 'market')
                        }
                        disabled={false}
                        textFieldLabel="Select Market"
                        sx={getInputCustomCommonSx(
                          colors,
                          undefined,
                          '#39ACE7'
                        )}
                        componentsProps={
                          getDashboardDropdownProps(colors)
                        }
                        renderOption={renderDashboardOption}
                        customTextFieldProps={
                          commonCustomTextFieldProps
                        }
                      />
                    </FormControl>
                  </Grid>
                </>
              )}

              {formDataDashboard.businessProgram === 'MOSAIC' && (
                <>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <CustomAutocomplete
                        options={businessStreamList}
                        noOptionsText="No business stream found"
                        value={
                          formDataDashboard.businessStream || null
                        }
                        onChange={(e, val) =>
                          handleChange(
                            e,
                            val,
                            'businessStream'
                          )
                        }
                        disabled={false}
                        textFieldLabel="Select Business Stream"
                        sx={getInputCustomCommonSx(
                          colors,
                          undefined,
                          '#39ACE7'
                        )}
                        componentsProps={
                          getDashboardDropdownProps(colors)
                        }
                        renderOption={renderDashboardOption}
                        customTextFieldProps={
                          commonCustomTextFieldProps
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <CustomAutocomplete
                        options={marketList}
                        noOptionsText="No market found"
                        value={
                          formDataDashboard.market || null
                        }
                        onChange={(e, val) =>
                          handleChange(e, val, 'market')
                        }
                        disabled={false}
                        textFieldLabel="Select Market"
                        sx={getInputCustomCommonSx(
                          colors,
                          undefined,
                          '#39ACE7'
                        )}
                        componentsProps={
                          getDashboardDropdownProps(colors)
                        }
                        renderOption={renderDashboardOption}
                        customTextFieldProps={
                          commonCustomTextFieldProps
                        }
                      />
                    </FormControl>
                  </Grid>
                </>
              )}
              {formDataDashboard.businessProgram === 'EDF' && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <CustomAutocomplete
                      options={domainList}
                      noOptionsText="No domain found"
                      value={
                        formDataDashboard.domain || null
                      }
                      onChange={(e, val) =>
                        handleChange(e, val, 'domain')
                      }
                      disabled={false}
                      textFieldLabel="Select Domain"
                      sx={getInputCustomCommonSx(
                        colors,
                        undefined,
                        '#39ACE7'
                      )}
                      componentsProps={
                        getDashboardDropdownProps(colors)
                      }
                      renderOption={renderDashboardOption}
                      customTextFieldProps={
                        commonCustomTextFieldProps
                      }
                    />
                  </FormControl>
                </Grid>
              )}


              <Grid item xs={4}>
                <CustomTextField
                  id="Description"
                  label={
                    <Box display="flex" alignItems="center">
                      Description
                    </Box>
                  }
                  name="Description"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.description}
                  error={formDataDashboard.description?.length > 45}
                  helperText="Description can't contain more that 45 characters."
                  onChange={(e) => handleChange(e, '', 'description')}
                  onBlur={(e) => handleOnBlur(e, 'description')}
                  onKeyDown={validateAliasInput}
                  disabled={true}
                  sx={inputCommonSx}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.consumer}
                    options={consumer}
                    noOptionsText="No Data found"
                    value={formDataDashboard.consumer}
                    onChange={(e, val) => handleChange(e, val, 'consumer')}
                    onInputChange={(e, val) => handleInputChange(e, 'consumer', val)}
                    disabled={true}
                    textFieldLabel="Primary Consumer/End Consumer"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.dependentReports}
                    options={report}
                    noOptionsText="No Data found"
                    value={formDataDashboard.dependentReports}
                    onChange={(e, val) => handleChange(e, val, 'report')}
                    onInputChange={(e, val) => handleInputChange(e, 'report', val)}
                    disabled={true}
                    textFieldLabel="Dependent Reports"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.dataClassifications}
                    options={dataClass}
                    noOptionsText="No Data found"
                    value={formDataDashboard.dataClassification}
                    onChange={(e, val) => handleChange(e, val, 'dataClassification')}
                    onInputChange={(e, val) => handleInputChange(e, 'dataClassification', val)}
                    disabled={true}
                    textFieldLabel="Data Classification"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.downstreamSystems}
                    options={downStream}
                    noOptionsText="No Data found"
                    value={formDataDashboard.downstreamSys}
                    onChange={(e, val) => handleChange(e, val, 'downstreamSys')}
                    onInputChange={(e, val) => handleInputChange(e, 'downstreamSys', val)}
                    disabled={true}
                    textFieldLabel="Downstream Systems"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12}>
                <Box
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '16px' }}
                >
                  <Typography
                    variant="subHeader"
                    color="dark.main"
                    style={{
                      color: 'rgba(0, 155, 216, 1)',
                      display: 'inline-block',
                      paddingRight: '20px',
                      position: 'absolute',
                      zIndex: 2
                    }}
                  >
                    Contacts
                  </Typography>
                  <Divider sx={{ flexGrow: 1, backgroundColor: 'rgba(0, 155, 216, 1)', marginLeft: 12 }} />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.dpmEmail}
                    options={dpmEmailList}
                    noOptionsText="No Data found"
                    value={formDataDashboard.dpmEmail}
                    onChange={(e, val) => handleChange(e, val, 'dpmEmail')}
                    onInputChange={(e, val) => handleInputChange(e, 'dpmEmail', val)}
                    disabled={false}
                    textFieldLabel="DPM *"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  id="DPMContact"
                  label={
                    <Box display="flex" alignItems="center">
                      DPM Contact *
                    </Box>
                  }
                  name="DPM Contact"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.dpmContact}
                  error={!!formDataDashboard.dpmContact}
                  onChange={(e) => handlePhoneChange(e, 'dpmContact')}
                  onBlur={(e) => handleOnBlur(e, 'dpmContact')}
                  inputProps={{
                    inputMode: 'tel',
                    pattern: '[0-9+\\-]*'
                  }}
                  sx={inputCommonSx}
                />
              </Grid>
              <Grid item xs={4} />

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.sustainleadEmail}
                    options={sustainleadEmailList}
                    noOptionsText="No Data found"
                    value={formDataDashboard.sustainleadEmail}
                    onChange={(e, val) => handleChange(e, val, 'sustainleadEmail')}
                    onInputChange={(e, val) => handleInputChange(e, 'sustainleadEmail', val)}
                    disabled={false}
                    textFieldLabel="D&AI Sustain Lead (@Name/GPID/Email) *"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  id="sustainLeadContact"
                  label={
                    <Box display="flex" alignItems="center">
                      D&AI Sustain Lead Contact *
                    </Box>
                  }
                  name="D&AI Sustain Lead Contact"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.sustainleadContact}
                  error={!!formDataDashboard.sustainleadContact}
                  onChange={(e) => handlePhoneChange(e, 'sustainleadContact')}
                  onBlur={(e) => handleOnBlur(e, 'sustainleadContact')}
                  inputProps={{
                    inputMode: 'tel',
                    pattern: '[0-9+\\-]*'
                  }}
                  sx={inputCommonSx}
                />
              </Grid>
              <Grid item xs={4} />

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <CustomAutocomplete
                    loading={dropdownLoading.escalationpointEmail}
                    options={escalationpointEmail}
                    noOptionsText="No Data found"
                    value={formDataDashboard.escalationpointEmail}
                    onChange={(e, val) => handleChange(e, val, 'escalationpointEmail')}
                    onInputChange={(e, val) => handleInputChange(e, 'escalationpointEmail', val)}
                    disabled={true}
                    textFieldLabel="Escalation Point"
                    sx={getInputCustomCommonSx(
                      colors,
                      undefined,
                      '#39ACE7'
                    )}
                    componentsProps={
                      getDashboardDropdownProps(colors)
                    }
                    renderOption={renderDashboardOption}
                    customTextFieldProps={commonCustomTextFieldProps}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  id="escalationpointContact"
                  label={
                    <Box display="flex" alignItems="center">
                      Escalation Point Contact
                    </Box>
                  }
                  name="Escalation Point Contact"
                  variant="outlined"
                  autoComplete="off"
                  value={formDataDashboard.escalationpointContact}
                  error={!!formDataDashboard.escalationpointContact}
                  onChange={(e) => handleChange(e, 'escalationpointContact')}
                  onBlur={(e) => handleOnBlur(e, 'escalationpointContact')}
                  inputProps={{
                    inputMode: 'tel',
                    pattern: '[0-9+\\-]*'
                  }}
                  disabled={true}
                  sx={inputCommonSx}
                />
              </Grid>
              <Grid item xs={4} />


            </Grid>
          </Box>

        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <Box bgcolor="backgroundLight.primary" display="flex">
            <AntSwitch
              checked={toggleState}
              onChange={handleToggleChange}
              color="primary"
              sx={{
                zIndex: 2,
                margin: '0px'
              }}
            />
            <span style={{ marginLeft: '5px' }}>
              <Typography variant="subtitle1" color="light.diff"
                style={{ color: 'rgba(169, 173, 203, 1)', fontWeight: '600', fontSize: '12px' }}>
                Data Quality
                <span style={{ marginLeft: '10px' }}>COMING SOON <Tooltip title={
                  <><Typography variant="body2" color="light.diff" style={{ fontSize: '13px', color: 'rgba(169, 173, 203, 1)', fontWeight: '500', fontStyle: 'italic' }}>Est. Arrival</Typography>
                    <Typography variant="body2" color="inherit" style={{ fontSize: '12px' }}>Aug 30, 2025</Typography>
                  </>
                } arrow><ComingSoonIcon style={{ verticalAlign: 'text-bottom' }} /></Tooltip></span>
              </Typography>
            </span>

          </Box>

        </Grid>

      </Grid>
    </Box>



  );

}